// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sglogo__wrapper{display:block;text-align:center}.sglogo__wrapper img{width:135px;height:auto}", ""]);
// Exports
module.exports = exports;
